import { OfferBannerConfig } from '../../models';

export const offerBannerConfig: OfferBannerConfig = {
  congratulation: false,
  showBenefit: true,
  showAction: true,
  showCreditSummary: true,
  showDetails: true,
  showHeadline: true,
  showLinks: true,
  showOffer: true
};

export const offerBannerConfigEnrollment: OfferBannerConfig = {
  congratulation: false,
  showBenefit: true,
  showAction: true,
  showCreditSummary: false,
  showDetails: true,
  showHeadline: true,
  showLinks: true,
  showOffer: true,
  enrollmentTheme: true
};

export const offerBannerConfigConfirmation: OfferBannerConfig = {
  congratulation: false,
  showAction: true,
  showBenefit: true,
  showCreditSummary: false,
  showDetails: true,
  showHeadline: true,
  showLinks: true,
  showOffer: true
};

export const congratsBannerConfig: OfferBannerConfig = {
  congratulation: true,
  showAction: false,
  showBenefit: false,
  showCreditSummary: false,
  showDetails: false,
  showHeadline: false,
  showLinks: false,
  showOffer: true
};

export const congratsBannerConfigExpressCheckout: OfferBannerConfig = {
  congratulation: true,
  showAction: false,
  showBenefit: false,
  showCreditSummary: false,
  showDetails: false,
  showHeadline: false,
  showLinks: false,
  showOffer: true
};
